/* eslint-disable @typescript-eslint/no-unused-expressions, @typescript-eslint/no-unused-vars */
import * as locale from 'locale-codes';
import { ILocale } from 'locale-codes';

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { Logger } from 'common/utility/logger/logger';
import { LocaleService } from 'services/locale/locale.service';

@Component({
  selector: 'ems-locale-selection',
  templateUrl: './locale-selection.component.html',
  styleUrls: ['./locale-selection.component.scss']
})
export class LocaleSelectionComponent implements OnInit {

  @Input() public selectedLocale: ILocale = locale.all[0]
  @Output() public selectedLocaleChange: EventEmitter<ILocale> = new EventEmitter<ILocale>();
  @Input() public showLabel: boolean = true

  constructor(private localeService: LocaleService) { }

  ngOnInit(): void {
    Logger.debug("ngOnInit: selectedLocale", this.selectedLocale)
    // this.selectedLocale = this.getLocale(this.selectedLocale) ?? this.selectedLocale
  }

  public get Locales(): Array<ILocale> {
    return this.localeService.Locales
  }

  public get AllowedLocales(): Array<ILocale> {
    return this.localeService.AllowedLocales
  }

  public getLocale(selectedLocale: ILocale): ILocale | undefined {
    return this.Locales.find(locale => locale.lcid === selectedLocale.lcid)
  }

  public getName(locale: ILocale): string {
    return this.localeService.getLocaleName(locale)
  }

  public getLabel(): string {
    return this.localeService.getLabel()
  }

  public LocaleChanged(event: MatSelectChange) {
    this.selectedLocale = event.value
    this.selectedLocaleChange.emit(this.selectedLocale)
    Logger.debug(`Selected Locale: ${this.selectedLocale.name}`)
  }

}
